import React, { useState } from 'react';
import * as Styles from './Account.style';
import { useTranslation, Trans } from 'react-i18next';
import { Highlight } from 'components/vm-deployment/components';
import { Heading } from 'assets/css/common-styles';
import { P } from 'components/reusable-css';
import VmPaymentForm from 'pages/member/new-vm/new-vm-step-7/vm-payment-form';
import { Formik } from 'formik';
import { initialValues, validate, cardError } from '../constants';
import Input from 'components/input';
import Checkbox from 'components/common/radio-button';
import { validationObject, validationChargedCard } from 'validations';
import { H6 } from 'components/reusable-css';
import { vm_amount, isChargeCard } from '../utils';
import { get } from 'lodash';
import { vs_amounts_options } from '../utils';
import { useMediaQuery } from '@mui/material';
import ConditionalFragment from 'components/conditional-fragment/ConditionalFragment';
import currencyFilter from 'utils/currency-filter';
import CreditCard from '../credit-card/CreditCard';
import { mockBillingInfo, mockUserAccountDetails, mockUserUiDetails } from 'pages/mockup/constant';

const Account = ({ storedCreditCards }) => {
  const rights = mockUserAccountDetails.user_rights;
  const userUI = mockUserUiDetails;
  const account_approved = mockUserAccountDetails.account_approved;
  const { t } = useTranslation();
  const matches = useMediaQuery('(max-width:450px)');
  const credit_card_info = mockBillingInfo;
  const initialSelectedItem = get(vs_amounts_options(mockBillingInfo?.billing_payment_amount_options), '[0]', {});
  const [isChecked, setIsChecked] = useState(initialSelectedItem.id);

  const handleVmPayment = async () => {};

  let input_width = matches
    ? { width: '80%', marginBottom: '3.5rem', paddingLeft: '2.2rem' }
    : { width: '17rem', marginBottom: '3.5rem', paddingLeft: '2.2rem' };
  let customChecked = isChecked === 'custom_amount';
  let validationSchema = !isChargeCard(credit_card_info)
    ? customChecked
      ? validationObject(true)
      : validationObject(false)
    : customChecked
    ? validationChargedCard
    : '';

  return (
    <>
      {userUI?.show_funds_deposit_section != 0 && (
        <Formik
          initialValues={{ ...initialValues, vm_price: initialSelectedItem.price }}
          enableReinitialize
          validationSchema={validationSchema}
          validate={(values) => validate(values, 'vm')}
          onSubmit={(values, { resetForm }) => handleVmPayment(values, resetForm)}
        >
          {(formikProp) => (
            <Styles.AccountSC>
              <Styles.Accounts>
                <Heading>
                  {account_approved == 1 ? (
                    <>
                      {mockBillingInfo?.billing_due_services == 1 ? (
                        <Trans
                          i18nKey="account/billing_info.string1"
                          components={{ highlight: <Highlight color="red" /> }}
                        />
                      ) : (
                        <Trans i18nKey="account/billing_info.string3" components={{ highlight: <Highlight /> }} />
                      )}
                    </>
                  ) : (
                    <Trans i18nKey="account/billing_info.string2" components={{ highlight: <Highlight /> }} />
                  )}
                </Heading>
                <Styles.Paragraphs>
                  {account_approved == 0 ? (
                    <>
                      <P>
                        {mockBillingInfo?.billing_due_services == 1
                          ? t('account/billing_info.string4')
                          : t('account/billing_info.string5')}
                      </P>
                      <P>{t('account/billing_info.string6')}</P>
                    </>
                  ) : (
                    <P>{t('account/billing_info.string7')}</P>
                  )}
                  <ConditionalFragment
                    condition={
                      Number(mockBillingInfo?.billing_vs_due_full_balance) > 0 ? true : rights.billingmakepmt !== 0
                    }
                  >
                    <P>{t('account/billing_info.string15')}</P>
                  </ConditionalFragment>
                  <ConditionalFragment
                    condition={
                      Number(mockBillingInfo?.billing_vs_due_full_balance) > 0 ? true : rights.billingmakepmt !== 0
                    }
                  >
                    <Styles.MidContent>
                      {Number(mockBillingInfo?.billing_vs_due_full_balance) > 0 && (
                        <Styles.Price
                          onClick={() => {
                            setIsChecked('due_amount');
                            formikProp.setFieldValue('vm_price', mockBillingInfo?.billing_vs_due_full_balance);
                          }}
                          key={'due_amount'}
                        >
                          <Checkbox
                            checkbox={isChecked}
                            setCheckedValue={() => {
                              setIsChecked('due_amount');
                              formikProp.setFieldValue('vm_price', mockBillingInfo?.billing_vs_due_full_balance);
                            }}
                            data={{ id: 'due_amount' }}
                          />
                          <H6>
                            <Trans
                              i18nKey={'account/billing_info.string18'}
                              values={{
                                price: currencyFilter(
                                  mockBillingInfo?.billing_vs_due_full_balance,
                                  mockUserAccountDetails?.account_currency,
                                ),
                              }}
                            />
                          </H6>
                        </Styles.Price>
                      )}
                      <Styles.Prices>
                        {(vs_amounts_options(mockBillingInfo?.billing_payment_amount_options) || []).map((price) => (
                          <Styles.Price
                            onClick={() => {
                              setIsChecked(price?.id);
                              formikProp.setFieldValue('vm_price', price?.price);
                            }}
                            key={price.id}
                          >
                            <Checkbox
                              checkbox={isChecked}
                              setCheckedValue={() => {
                                setIsChecked(price?.id);
                                formikProp.setFieldValue('vm_price', price?.price);
                              }}
                              data={price}
                            />
                            <H6> {currencyFilter(price?.price, mockUserAccountDetails?.account_currency)} </H6>
                          </Styles.Price>
                        ))}
                        <Styles.Price
                          onClick={() => {
                            setIsChecked('custom_amount');
                            formikProp.setFieldValue('vm_price', 'custom_amount');
                          }}
                          key={'custom_amount'}
                        >
                          <Checkbox
                            checkbox={isChecked}
                            setCheckedValue={() => {
                              setIsChecked('custom_amount');
                              formikProp.setFieldValue('vm_price', 'custom_amount');
                            }}
                            data={{ id: 'custom_amount' }}
                          />
                          <H6>
                            <Trans
                              i18nKey={'account/billing_info.string19'}
                              values={{ currency_symbol: mockUserAccountDetails.account_currency_symbol }}
                            />
                          </H6>
                        </Styles.Price>
                      </Styles.Prices>
                      <Styles.InputPaddingLeft>
                        <Input
                          styling={input_width}
                          placeholder={t('account/billing_info.string20')}
                          type={'text'}
                          name={'custom_vs_amount'}
                          onFocus={() => {
                            setIsChecked('custom_amount');
                            formikProp.setFieldValue('vm_price', 'custom_amount');
                          }}
                          value={formikProp.values['custom_vs_amount']}
                          onChange={formikProp.handleChange}
                          onBlur={formikProp.handleBlur}
                          error={formikProp.errors['custom_vs_amount']}
                          touched={formikProp.touched['custom_vs_amount']}
                          dataTooltip={t('account/billing_info.string38')}
                        />
                        <div
                          id="Add_funds_vm"
                          style={
                            customChecked && formikProp?.values.custom_vs_amount < 10
                              ? { opacity: '0.3', pointerEvents: 'none' }
                              : {}
                          }
                        >
                          <VmPaymentForm
                            addFunds
                            amount={vm_amount(formikProp.values)}
                            paraAddfunds
                            formikProp={formikProp}
                            cardError={() => cardError(formikProp.errors, formikProp.values, 'vm')}
                            creditCardButtonLoading={false}
                            creditCardButtonDisabled={customChecked && formikProp?.values.custom_vs_amount < 10}
                            isButton
                          />
                        </div>
                      </Styles.InputPaddingLeft>
                    </Styles.MidContent>
                  </ConditionalFragment>
                </Styles.Paragraphs>
              </Styles.Accounts>
            </Styles.AccountSC>
          )}
        </Formik>
      )}

      <ConditionalFragment condition={rights.billingviewcc !== 0}>
        <CreditCard rights={rights} storedCreditCards={storedCreditCards} />
      </ConditionalFragment>
    </>
  );
};
export default Account;
